import React from "react"
import { Header, Menu, Button, Box, Heading } from "grommet";
import { Sun, Moon } from "grommet-icons";
import { useNavigate } from "react-router";

export const AppBar = (props: any) => {
    const { setDark, dark } = props;
    const navigate = useNavigate();
    return (
        <Header
            background="green_background"
            pad={{ left: "medium", right: "small", vertical: "small" }}
            elevation="none">
            <div style={{ flex: "auto" }}>
                <Button onClick={() => navigate("/")}><Heading weight="normal" margin="none" color="green_foreground" alignSelf="center"> Bingtrania </Heading></Button>
            </div>
            <Menu
                icon={false}
                label="Menu"
                items={[
                    { label: 'Home', onClick: () => { navigate("/") } },
                    { label: 'Event', onClick: () => { navigate("/event") } },
                    { label: 'Schedule', onClick: () => { navigate("/schedule") } },
                    { label: 'Travel', onClick: () => { navigate("/travel") } },
                    { label: 'Attire', onClick: () => { navigate("/attire") } },
                    { label: 'Registry', onClick: () => { navigate("/registry") } },
                    { label: 'RSVP', onClick: () => { navigate("/rsvp") } },
                    { label: 'Reviews', onClick: () => { navigate("/reviews") } }
                ]}
                dropBackground="charcoal"
                dropProps={{ elevation: "none" }}
            />
            <Button
                pad="xsmall"
                secondary
                a11yTitle={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                icon={dark ? <Moon color="orange" /> : <Sun color="green_foreground" />}
                onClick={() => setDark(!dark)}
                tip={{
                    content: (
                        <Box
                            pad="small"
                            round="small"
                            background="cream"
                        >
                            {dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                        </Box>
                    ),
                    plain: true,
                }}
            />
        </Header>);
}